// extracted by mini-css-extract-plugin
module.exports = {"BreakLimits":"BreakLimits_BreakLimits__9sSo2"};